import { render, staticRenderFns } from "./ItemDetailPriceLayout.vue?vue&type=template&id=2c648a0a&scoped=true"
import script from "./ItemDetailPriceLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailPriceLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c648a0a",
  null
  
)

export default component.exports